import { render, staticRenderFns } from "./productionModel.vue?vue&type=template&id=672b1866&scoped=true&"
import script from "./productionModel.vue?vue&type=script&lang=js&"
export * from "./productionModel.vue?vue&type=script&lang=js&"
import style0 from "./productionModel.vue?vue&type=style&index=0&id=672b1866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b1866",
  null
  
)

export default component.exports